var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"w-full flex flex-wrap list-counter mt-3 mb-5"},_vm._l((_vm.items),function(item){return _c('li',{key:item,staticClass:"w-full sm:w-auto mr-6 lg:mr-6 md:mr-2 text-xl md:text-base lg:text-xl"},[_vm._v(" "+_vm._s(item)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }